import { useFormikContext } from "formik";
import { VerticalForm } from "melco-shared-logic";
import { Button, DatePicker, SaveIcon, Alert, FormItem } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";




type DisplayExtendTrialFormProps = {

  referenceDrawer?: DrawerType
};

export const DisplayExtendTrialForm: React.FC<DisplayExtendTrialFormProps> = (
) => {

  const { t } = useTranslation();
  const { submitForm, setFieldValue, } = useFormikContext();

  return (
    <>
      <div>


        <VerticalForm>
          <FormItem>
            <Alert
              message={t("users.tabs.trials.actions.extendtrial.info")}
              type="info"
              withBackground
              closable={false}
            />
          </FormItem>

          <FormItem
            label={t("users.tabs.trials.actions.extendtrial.trial_end_date")}>
            <DatePicker
              name="extendTrialDateTime"
              onChange={(value) => {
                const datetime = (value && value.startOf("day").toDate()) ?? undefined;
                setFieldValue("extendTrialDateTime", datetime)
              }
              }
              style={{ "width": "100%" }}
            />
          </FormItem>

          <Button
            icon={<SaveIcon />}
            type="primary"
            onClick={() => {
              submitForm();
            }}
          >
            {t("users.tabs.trials.actions.extendtrial.save")}
          </Button>
        </VerticalForm>
      </div>
    </>
  );
};
